import { containerScoped } from '~/decorators/dependency-container'
import { Seller } from '~/models/classified/types'

@containerScoped()
export default class UserVerificationChecker {
  sellerIsVerified(seller: Seller): boolean {
    return Boolean(
      seller?.verification?.telephoneVerified ||
        seller?.verification?.telephoneVerified
    )
  }
}
